import script from "./UserSharesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSharesTab.vue?vue&type=script&setup=true&lang=ts"

import "./UserSharesTab.vue?vue&type=style&index=0&id=48ccbb69&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ccbb69"]])

export default __exports__